/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Origin } from './Origin';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
    OriginToJSONTyped,
} from './Origin';
import type { MakeupStatus } from './MakeupStatus';
import {
    MakeupStatusFromJSON,
    MakeupStatusFromJSONTyped,
    MakeupStatusToJSON,
    MakeupStatusToJSONTyped,
} from './MakeupStatus';
import type { IdNameResultOflong } from './IdNameResultOflong';
import {
    IdNameResultOflongFromJSON,
    IdNameResultOflongFromJSONTyped,
    IdNameResultOflongToJSON,
    IdNameResultOflongToJSONTyped,
} from './IdNameResultOflong';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';
import type { UserTaskStatus } from './UserTaskStatus';
import {
    UserTaskStatusFromJSON,
    UserTaskStatusFromJSONTyped,
    UserTaskStatusToJSON,
    UserTaskStatusToJSONTyped,
} from './UserTaskStatus';

/**
 * 
 * @export
 * @interface GetMakeupResponse
 */
export interface GetMakeupResponse {
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    attendanceLogId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetMakeupResponse
     */
    sourceSessionDate: Date;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetMakeupResponse
     */
    student: IdNameResultOfint;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetMakeupResponse
     */
    _class: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetMakeupResponse
     */
    makeupClass: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOflong}
     * @memberof GetMakeupResponse
     */
    appointmentId: IdNameResultOflong | null;
    /**
     * 
     * @type {IdNameResultOflong}
     * @memberof GetMakeupResponse
     */
    makeupAppointmentId: IdNameResultOflong | null;
    /**
     * 
     * @type {MakeupStatus}
     * @memberof GetMakeupResponse
     */
    status: MakeupStatus;
    /**
     * 
     * @type {Origin}
     * @memberof GetMakeupResponse
     */
    origin: Origin;
    /**
     * 
     * @type {Date}
     * @memberof GetMakeupResponse
     */
    requestedDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    requestedStartTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    requestedEndTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    requestNote: string | null;
    /**
     * 
     * @type {any}
     * @memberof GetMakeupResponse
     */
    suggestedDate: any | null;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    suggestedStartTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    suggestedEndTime: string | null;
    /**
     * 
     * @type {any}
     * @memberof GetMakeupResponse
     */
    approvedDate: any | null;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    approvedStartTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    approvedEndTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    reviewNote: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    cancellationReason: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetMakeupResponse
     */
    requestedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetMakeupResponse
     */
    reviewedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetMakeupResponse
     */
    cancelledAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    processingTaskId?: string | null;
    /**
     * 
     * @type {UserTaskStatus}
     * @memberof GetMakeupResponse
     */
    processingTaskStatus?: UserTaskStatus | null;
    /**
     * 
     * @type {string}
     * @memberof GetMakeupResponse
     */
    reviewingByEmail?: string | null;
}



/**
 * Check if a given object implements the GetMakeupResponse interface.
 */
export function instanceOfGetMakeupResponse(value: object): value is GetMakeupResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('attendanceLogId' in value) || value['attendanceLogId'] === undefined) return false;
    if (!('sourceSessionDate' in value) || value['sourceSessionDate'] === undefined) return false;
    if (!('student' in value) || value['student'] === undefined) return false;
    if (!('_class' in value) || value['_class'] === undefined) return false;
    if (!('makeupClass' in value) || value['makeupClass'] === undefined) return false;
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('makeupAppointmentId' in value) || value['makeupAppointmentId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('requestedDate' in value) || value['requestedDate'] === undefined) return false;
    if (!('requestedStartTime' in value) || value['requestedStartTime'] === undefined) return false;
    if (!('requestedEndTime' in value) || value['requestedEndTime'] === undefined) return false;
    if (!('requestNote' in value) || value['requestNote'] === undefined) return false;
    if (!('suggestedDate' in value) || value['suggestedDate'] === undefined) return false;
    if (!('suggestedStartTime' in value) || value['suggestedStartTime'] === undefined) return false;
    if (!('suggestedEndTime' in value) || value['suggestedEndTime'] === undefined) return false;
    if (!('approvedDate' in value) || value['approvedDate'] === undefined) return false;
    if (!('approvedStartTime' in value) || value['approvedStartTime'] === undefined) return false;
    if (!('approvedEndTime' in value) || value['approvedEndTime'] === undefined) return false;
    if (!('reviewNote' in value) || value['reviewNote'] === undefined) return false;
    if (!('cancellationReason' in value) || value['cancellationReason'] === undefined) return false;
    if (!('requestedAt' in value) || value['requestedAt'] === undefined) return false;
    if (!('reviewedAt' in value) || value['reviewedAt'] === undefined) return false;
    if (!('cancelledAt' in value) || value['cancelledAt'] === undefined) return false;
    return true;
}

export function GetMakeupResponseFromJSON(json: any): GetMakeupResponse {
    return GetMakeupResponseFromJSONTyped(json, false);
}

export function GetMakeupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMakeupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'attendanceLogId': json['attendanceLogId'],
        'sourceSessionDate': (new Date(json['sourceSessionDate'])),
        'student': IdNameResultOfintFromJSON(json['student']),
        '_class': IdNameResultOfintFromJSON(json['class']),
        'makeupClass': IdNameResultOfintFromJSON(json['makeupClass']),
        'appointmentId': IdNameResultOflongFromJSON(json['appointmentId']),
        'makeupAppointmentId': IdNameResultOflongFromJSON(json['makeupAppointmentId']),
        'status': MakeupStatusFromJSON(json['status']),
        'origin': OriginFromJSON(json['origin']),
        'requestedDate': (new Date(json['requestedDate'])),
        'requestedStartTime': json['requestedStartTime'],
        'requestedEndTime': json['requestedEndTime'],
        'requestNote': json['requestNote'],
        'suggestedDate': json['suggestedDate'],
        'suggestedStartTime': json['suggestedStartTime'],
        'suggestedEndTime': json['suggestedEndTime'],
        'approvedDate': json['approvedDate'],
        'approvedStartTime': json['approvedStartTime'],
        'approvedEndTime': json['approvedEndTime'],
        'reviewNote': json['reviewNote'],
        'cancellationReason': json['cancellationReason'],
        'requestedAt': (new Date(json['requestedAt'])),
        'reviewedAt': (json['reviewedAt'] == null ? null : new Date(json['reviewedAt'])),
        'cancelledAt': (json['cancelledAt'] == null ? null : new Date(json['cancelledAt'])),
        'processingTaskId': json['processingTaskId'] == null ? undefined : json['processingTaskId'],
        'processingTaskStatus': json['processingTaskStatus'] == null ? undefined : UserTaskStatusFromJSON(json['processingTaskStatus']),
        'reviewingByEmail': json['reviewingByEmail'] == null ? undefined : json['reviewingByEmail'],
    };
}

export function GetMakeupResponseToJSON(json: any): GetMakeupResponse {
    return GetMakeupResponseToJSONTyped(json, false);
}

export function GetMakeupResponseToJSONTyped(value?: GetMakeupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'attendanceLogId': value['attendanceLogId'],
        'sourceSessionDate': value['sourceSessionDate'].toISOString().substring(0,10),
        'student': IdNameResultOfintToJSON(value['student']),
        'class': IdNameResultOfintToJSON(value['_class']),
        'makeupClass': IdNameResultOfintToJSON(value['makeupClass']),
        'appointmentId': IdNameResultOflongToJSON(value['appointmentId']),
        'makeupAppointmentId': IdNameResultOflongToJSON(value['makeupAppointmentId']),
        'status': MakeupStatusToJSON(value['status']),
        'origin': OriginToJSON(value['origin']),
        'requestedDate': value['requestedDate'].toISOString().substring(0,10),
        'requestedStartTime': value['requestedStartTime'],
        'requestedEndTime': value['requestedEndTime'],
        'requestNote': value['requestNote'],
        'suggestedDate': value['suggestedDate'],
        'suggestedStartTime': value['suggestedStartTime'],
        'suggestedEndTime': value['suggestedEndTime'],
        'approvedDate': value['approvedDate'],
        'approvedStartTime': value['approvedStartTime'],
        'approvedEndTime': value['approvedEndTime'],
        'reviewNote': value['reviewNote'],
        'cancellationReason': value['cancellationReason'],
        'requestedAt': value['requestedAt'].toISOString(),
        'reviewedAt': value['reviewedAt'] == null ? value['reviewedAt'] : value['reviewedAt'].toISOString(),
        'cancelledAt': value['cancelledAt'] == null ? value['cancelledAt'] : value['cancelledAt'].toISOString(),
        'processingTaskId': value['processingTaskId'],
        'processingTaskStatus': UserTaskStatusToJSON(value['processingTaskStatus']),
        'reviewingByEmail': value['reviewingByEmail'],
    };
}

